
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAnalogInleftLeft75 as ObiThreewayAnalogInleftLeft75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-analog-inleft-left-75.js';
 
 
 

 
 export const ObiThreewayAnalogInleftLeft75 = createComponent({
   react: React,
   tagName: 'obi-threeway-analog-inleft-left-75',
   elementClass: ObiThreewayAnalogInleftLeft75Element,
   events: {
     
   }
  });
 
 